
import { Textarea } from "@/components/ui/textarea";

type CourseDescriptionFieldProps = {
  description: string;
  onChange: (value: string) => void;
  isEditing: boolean;
};

export function CourseDescriptionField({ 
  description, 
  onChange, 
  isEditing 
}: CourseDescriptionFieldProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Description</label>
      {isEditing ? (
        <Textarea
          value={description}
          onChange={(e) => onChange(e.target.value)}
          rows={4}
        />
      ) : (
        <div className="whitespace-pre-wrap">{description}</div>
      )}
    </div>
  );
}
